import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Immutable from 'immutable';

import { bibShape, checkedOutItemShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import { Button } from '@bibliocommons/base-buttons';
import { Link } from '@bibliocommons/base-links';

export class DownloadButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleOpen() {
    this.props.modalActions.openModal(this.props.modalKey, { accountRequired: true });
  }

  handleClick() {
    const { bib, trackCheckoutConsumeDownload } = this.props;
    if (typeof trackCheckoutConsumeDownload === 'function') {
      const bibId = bib.get('id');
      this.props.trackCheckoutConsumeDownload(bibId);
    }
  }

  render() {
    const { checkoutItem, bib, intl } = this.props;
    const materialPolicy = bib.getIn(['policy', 'materialPolicy'], Immutable.Map());

    if (checkoutItem.get('downloadUrl') && checkoutItem.get('format')) {
      return (
        <Link
          className="cp-download-button"
          target="_blank"
          href={checkoutItem.get('downloadUrl')}
          dataKey="download-link"
          handleClick={this.handleClick}
        >
          <FormattedMessage
            id="download_now_format"
            values={{
              format: intl.formatMessage({ id: `digiformat_${checkoutItem.get('format').toLowerCase()}` })
            }}
          />
        </Link>
      );
    }

    if (materialPolicy.get('supportsDownload')) {
      return (
        <Button className="cp-download-button" handleClick={this.handleOpen} dataKey="download-button">
          <FormattedMessage id="download" />
        </Button>
      );
    }

    if (!checkoutItem.get('thirdPartyReaderUrl')) {
      const helpLink = checkoutItem.get('format') ? materialPolicy.get('helpUrl') : materialPolicy.get('quickStartUrl');

      return (
        <Link className="cp-download-button" href={helpLink} target="_blank" dataKey="download-help-link">
          <FormattedMessage id="how_to_access_title" />
        </Link>
      );
    }

    return null;
  }
}

DownloadButton.propTypes = {
  bib: bibShape.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  checkoutItem: checkedOutItemShape.isRequired,
  modalKey: PropTypes.string.isRequired,
  trackCheckoutConsumeDownload: PropTypes.func
};

export default injectIntl(DownloadButton);
